import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { connect, StudentCard } from 'omni-common-ui';
import * as studentAccessors from 'containers/Student/accessors';
import * as studentActions from 'containers/Student/actions';
import UserCardPlaceholder from 'components/UserCardPlaceholder';

class StudentCardProfile extends PureComponent {
  componentWillMount() {
    this._loadIfNeeded(this.props);
  }

  componentWillReceiveProps(props) {
    this._loadIfNeeded(props);
  }

  _loadIfNeeded({ studentId }) {
    this.props.fetchStudentIfNeeded(studentId);
  }

  _getStudentAcademicLinkHref() {
    const { studentId } = this.props;
    return this.props.buildRoute(`/student/${studentId}`);
  }

  _renderNameNode() {
    const { student } = this.props;
    if (! student) return '…';
    return <Link to={this._getStudentAcademicLinkHref()}>
      {student.firstName} {student.lastName}
    </Link>;
  }

  _renderLocalNameNode() {
    const { student } = this.props;
    if (! student) return null;
    return <span>{student.localName}</span>;
  }

  render() {
    const {
      className,
      student,
      status,
      statusHighlighted,
      useLowerLevelPersonComponent,
    } = this.props;

    const studentInfo = student ? student.toJS() : null;

    if (useLowerLevelPersonComponent) {
      if (! student) {
        return <UserCardPlaceholder className={classnames(className, styles.__placeholder)}
            isLoading />;
      }

      return <StudentCard.Person backgroundless
          className={className}
          {...studentInfo}
          nameLink={this._getStudentAcademicLinkHref()}
          nameNode={<Link to={this._getStudentAcademicLinkHref()}>
            {studentInfo.firstName} {studentInfo.lastName}
          </Link>}
          localNameNode={<span>
            {studentInfo.localName}
          </span>}
          status={status}
          statusHighlighted={statusHighlighted} />;
    }

    if (! studentInfo) {
      return <StudentCard.Profile isPlaceholder
          {...this.props}
          {...studentInfo} />;
    }

    return <StudentCard.Profile nameLink={this._getStudentAcademicLinkHref()}
        name={studentInfo.firstName}
        surname={studentInfo.lastName}
        {...this.props}
        {...studentInfo} />;
  }
}

StudentCardProfile.propTypes = {
  className: PropTypes.string,
  studentId: PropTypes.string,
  student: PropTypes.object,
  status: PropTypes.string,
  statusHighlighted: PropTypes.string,
  buildRoute: PropTypes.func.isRequired,
  fetchStudentIfNeeded: PropTypes.func.isRequired,
  useLowerLevelPersonComponent: PropTypes.bool,
};

function mapStateToProps(state, { studentId }) {
  return {
    student: studentAccessors.getStudentById(state, `${studentId}`),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(studentActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentCardProfile);



// WEBPACK FOOTER //
// ./containers/StudentCardProfile/index.jsx